"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLanguageProperty = exports.languagePropertyDefinition = void 0;
exports.languagePropertyDefinition = {
    view: { label: 'Language' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'language',
};
const isLanguageProperty = (prop) => {
    return prop.name === exports.languagePropertyDefinition.name;
};
exports.isLanguageProperty = isLanguageProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGFuZ3VhZ2UucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9sYW5ndWFnZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDBCQUEwQixHQUFHO0lBQ3hDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxVQUFVLEVBQUU7SUFDM0IsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLFVBQVU7Q0FDZSxDQUFBO0FBSTFCLE1BQU0sa0JBQWtCLEdBQUcsQ0FBQyxJQUFrQixFQUE0QixFQUFFO0lBQ2pGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxrQ0FBMEIsQ0FBQyxJQUFJLENBQUE7QUFDdEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxrQkFBa0Isc0JBRTlCIn0=